/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'credit-card': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M546.112 716.8h-204.8v68.288h204.8V716.8zm-273.024 0H136.576v68.288h136.576V716.8zM85.376 853.312c-4.608 0-8.576-1.664-12.032-4.992-3.392-3.392-5.056-7.424-5.056-12.032V512h887.424v324.288c0 4.608-1.664 8.576-4.992 12.032-3.392 3.328-7.424 4.992-12.032 4.992H85.376zm853.312-682.624c4.608 0 8.576 1.664 12.032 5.056 3.328 3.328 4.992 7.36 4.992 12.032v119.488H68.288V187.776c0-4.672 1.664-8.64 5.056-12.032 3.392-3.392 7.424-5.056 12.032-5.056h853.312zM85.376 102.4c-23.488 0-43.52 8.384-60.288 25.088C8.384 144.256 0 164.288 0 187.776v648.512c0 23.488 8.384 43.52 25.088 60.288 16.704 16.64 36.8 25.024 60.288 25.024h853.312c23.488 0 43.52-8.384 60.288-25.024 16.64-16.768 25.024-36.8 25.024-60.288V187.776c0-23.488-8.384-43.52-25.024-60.288-16.704-16.704-36.8-25.088-60.288-25.088H85.376z"/>'
  }
})
